import { i18n } from '@apps/main/modules/localization/localizationSetup';

import type { AppSingleSelectOption } from '@libs/ui';

const { t } = i18n.global;
export function getTicketsAmountOptions(
  min = 0,
  max = 99
): AppSingleSelectOption<number>[] {
  const options: AppSingleSelectOption<number>[] = [];

  for (let amount = min; amount <= max; amount++) {
    if (amount !== 0) {
      options.push({
        id: amount,
        label: amount.toString(),
      });
    }
  }
  return [ZERO_OPTION, SAME_AS_TRAVELERS_OPTION, ...options];
}

export const ZERO_OPTION: AppSingleSelectOption<number> = {
  id: 0,
  label: '0',
};

export const SAME_AS_TRAVELERS_OPTION: AppSingleSelectOption<number> = {
  id: -1,
  label: `${t('planner.match_trip_travelers')}`,
};
